<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiAccountOutline } from "@mdi/js"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type {
    WorkOrderAssignmentRequesterContact,
    WorkOrderAssignmentRow,
  } from "../../../../contract"

  let { row }: { row: WorkOrderAssignmentRow } = $props()

  const requesterContact = $derived<WorkOrderAssignmentRequesterContact>(
    row.requesterContact ?? {
      name: row.customerLabel || "Ansprechpartner",
      roleLabel: "—",
      tooltipContent: null,
    },
  )
</script>

<div class="requester-contact-cell" class:disabled={row.disabled}>
  <StatusTag
    variant="neutral"
    size="sm"
    label={requesterContact.name}
    subLabel={requesterContact.roleLabel}
    color="blue"
    icon={mdiAccountOutline}
    tooltipContent={requesterContact.tooltipContent ?? ""}
    tooltipHtml={Boolean(requesterContact.tooltipContent)}
    tooltipClassName={requesterContact.tooltipContent ? RICH_TOOLTIP_CLASS : undefined}
    disableTitle={true}
  />
</div>

<style lang="less">
  .requester-contact-cell {
    display: flex;
    min-width: 0;
    max-width: 260px;
    overflow-wrap: anywhere;
  }

  .requester-contact-cell.disabled {
    opacity: 0.6;
  }
</style>
